export default "__VITE_ASSET__334203c5__"